import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstVd4: [],
		vd4: {
			vd4conpgto: null,
			vd4nome: null,
			vd4titulo: null,
			vd4foracat: false,
			vd4limdesc: 0,
			lstVd9: [],
		},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
		getVd4: state => {
			state.vd4.vd4limdesc = parseFloat(state.vd4.vd4limdesc)
			return state.vd4
		},
		getLstVd4: state => state.lstVd4,
		getLastUpdatedRegister: state => state.lastUpdatedRegister,
		getItemsPerPage: state => state.itemsPerPage,
		getSearch: state => state.search,
		getHasNext: state => state.hasNext,
		getVd4conpgto: state => (state.vd4 ? state.vd4.vd4conpgto : null),
		getLstVd9: state => (state.vd4 ? state.vd4.lstVd9 : []),
	},
	mutations: {
		setVd4: (state, vd4) => (state.vd4 = vd4),
		setInsert: (state, insert) => (state.insert = insert),
		setUpdate: (state, update) => (state.update = update),
		setSearch: (state, search) => (state.search = search),
		setLoading: (state, loading) => (state.loading = loading),
		setLstVd4: (state, lstVd4) => (state.lstVd4 = lstVd4),
		setLstVd9: (state, lstVd9) => (state.vd4.lstVd9 = lstVd9),
		set(state, vd4) {
			state.vd4 = vd4
			if (vd4) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.vd4 = {
				vd4conpgto: null,
				vd4nome: null,
				vd4titulo: null,
				vd4foracat: false,
				vd4limdesc: 0,
				lstVd9: [],
			}
		},
		setParamsDataTable(state, payload) {
			state.lstVd4 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		setVd4: ({ commit }, vd4) => commit("setVd4", vd4),
		setInsert: ({ commit }, insert) => {
			commit("setInsert", insert)
			commit("setUpdate", !insert)
		},
		setUpdate: ({ commit }, update) => {
			commit("setUpdate", update)
			commit("setInsert", !update)
		},
		setSearch: ({ commit }, search) => commit("setSearch", search),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		setLstVd4: ({ commit }, lstVd4) => commit("setLstVd4", lstVd4),
		setLstVd9: ({ commit, rootGetters }, lstVd9) => {
			if (lstVd9.length != 0) {
				var lstDc1 = rootGetters["form/getLstDc1"]
				var dc1tamanho = lstDc1.find(
					dc1 => dc1.dc1campo.toLocaleUpperCase() === "vd9parcela".toLocaleUpperCase(),
				).dc1tamanho
				lstVd9.forEach((vd9, i) => {
					vd9.vd9parcela = (i + 1).toString().padStart(dc1tamanho, "0")
				})
			}
			commit("setLstVd9", lstVd9)
		},
		deleteVd9Line: ({ dispatch, getters }, index) => {
			var lstVd9 = getters.getLstVd9
			lstVd9.splice(index, 1)
			dispatch("setLstVd9", lstVd9)
		},
		addVd9Line: ({ dispatch, getters }) => {
			var lstVd9 = getters.getLstVd9
			lstVd9.push({
				vd9conpgto: getters.getVd4conpgto,
				vd9caren: 0,
			})
			dispatch("setLstVd9", lstVd9)
			return lstVd9[lstVd9.length - 1].vd9parcela
		},
		initForm: ({ commit }) => commit("initForm"),
		async get({ dispatch }, vd4conpgto) {
			return await this._vm.$axios
				.get(`/PaymentCondition/PaymentCondition/Find/${vd4conpgto}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async find({ commit, dispatch }, { vd4conpgto }) {
			commit("setLoading", true)
			commit("initForm")
			await dispatch("get", vd4conpgto)
				.then(vd4 => {
					commit("set", vd4)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ dispatch, getters }) {
			if (getters.getLstVd9.length != 0) {
				dispatch(
					"setLstVd9",
					getters.getLstVd9.map(vd9 => {
						return {
							vd9conpgto: vd9.vd9conpgto,
							vd9caren: parseInt(vd9.vd9caren),
							vd9parcela: vd9.vd9parcela,
						}
					}),
				)
			}

			if (getters.getVd4conpgto) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/PaymentCondition/PaymentCondition/Insert", getters.getVd4)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("initForm")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/PaymentCondition/PaymentCondition/Update", getters.getVd4)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("initForm")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.delete(`/PaymentCondition/PaymentCondition/Delete/${getters.getVd4conpgto}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/PaymentCondition/PaymentCondition/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstVd4", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async findLastByCustomer({ dispatch }, cf1cliente) {
			return await this._vm.$axios
				.get(`/PaymentCondition/PaymentCondition/FindLastByCustomer/${cf1cliente}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findAllVd4({ dispatch, commit }) {
			return await this._vm.$axios
				.get("/PaymentCondition/PaymentCondition/findAllVd4")
				.then(response => {
					let lstVd4 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstVd4", lstVd4)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
	},
}
